import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import Seo from "@/lib/Seo";
import { api, mediaUrl, formatDate } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function Article() {
  const { slug } = useParams();
  const [post, setPost] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setPost(null);
    setNotFound(false);
    api.get(`/public/blog/${slug}`).then((r) => setPost(r.data)).catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <section className="py-24 text-center" data-testid="article-not-found">
        <h1 className="font-display text-3xl font-extrabold uppercase text-onyx">Article introuvable</h1>
        <Link to="/actualites" className="mt-6 inline-block text-rouge font-bold uppercase text-sm tracking-wide hover:text-rouge-hover">
          ← Retour aux actualités
        </Link>
      </section>
    );
  }

  if (!post) return <section className="py-24 container-x" data-testid="article-loading"><p className="text-muted-foreground">Chargement…</p></section>;

  return (
    <>
      <Seo title={post.seo_title || post.title} description={post.meta_description || post.excerpt}
        path={`/actualites/${post.slug}`} image={post.image}
        jsonLd={{ "@context": "https://schema.org", "@type": "Article", headline: post.title, datePublished: post.published_at, image: mediaUrl(post.image) }} />
      <article className="py-14 sm:py-20" data-testid="article-page">
        <div className="container-x max-w-3xl">
          <Reveal>
            <Link to="/actualites" data-testid="article-back" className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-wide text-rouge hover:text-rouge-hover transition-colors mb-8">
              <ArrowLeft className="w-4 h-4" /> Actualités
            </Link>
            <p className="font-mono text-xs text-muted-foreground mb-4">{formatDate(post.published_at)}</p>
            <h1 className="font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight uppercase leading-[1.05] text-onyx" data-testid="article-title">
              {post.title}
            </h1>
            {post.image && (
              <img src={mediaUrl(post.image)} alt={post.title} className="w-full mt-10 border border-line bg-white" data-testid="article-image" />
            )}
            <div className="mt-10 space-y-5 text-base sm:text-lg leading-relaxed text-foreground/85" data-testid="article-content">
              {(post.content || "").split(/\n{2,}/).filter(Boolean).map((para, i) => (
                <p key={i}>{para}</p>
              ))}
            </div>
          </Reveal>
        </div>
      </article>
    </>
  );
}
